import React from 'react';
import { Tag, Tooltip } from 'antd';

const UserRolesDisplay = ({ roleDetails = [], maxDisplay = 2 }) => {
  if (!roleDetails || !roleDetails.length) {
    return <Tag color="default">Chưa có vai trò</Tag>;
  }

  const displayRoles = roleDetails.slice(0, maxDisplay);
  const remainingCount = roleDetails.length - maxDisplay;

  return (
    <div>
      {displayRoles.map((role) => (
        <Tag key={role.id} color="blue" style={{ marginBottom: 4 }}>
          {role.name}
        </Tag>
      ))}
      {remainingCount > 0 && (
        <Tooltip
          title={roleDetails
            .slice(maxDisplay)
            .map((role) => role.name)
            .join(', ')}>
          <Tag color="geekblue">+{remainingCount}</Tag>
        </Tooltip>
      )}
    </div>
  );
};

export default UserRolesDisplay;
